import type { ComponentPropsWithoutRef } from "react"
import "./MessageReactions.scss"
import { EmojiData } from "../types"
import type { Message } from "../types"

interface MessageReactionsProps extends ComponentPropsWithoutRef<"div"> {
    message: Message
    setReactionMessage: (reactions: Message | undefined) => void
}

export function MessageReactions({
    message,
    setReactionMessage,
}: MessageReactionsProps) {
    const reactionSpans = []
    if (message.reactions === undefined) {
        return <div className="message-reactions" />
    }
    const sortedReactions = Object.entries(message.reactions).sort((a, b) => {
        return a["1"].split(":")[1] > b["1"].split(":")[1] ? 1 : -1
    })
    for (const value of sortedReactions) {
        const selection = value["1"].split(":")[0]
        const emoji = EmojiData.get(selection)
        reactionSpans.push(
            <span className="emoji-reaction" key={value["1"]}>
                {emoji}
            </span>,
        )
    }
    return (
        <div
            className="message-reactions"
            onClick={() => {
                setReactionMessage(message)
            }}
        >
            {reactionSpans}
        </div>
    )
}
